import { render, staticRenderFns } from "./userCountry.vue?vue&type=template&id=fa06e6a4"
import script from "./userCountry.vue?vue&type=script&lang=js"
export * from "./userCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserHeader: require('/root/workspace/web-company_Yo6Q/components/userLogin/userHeader.vue').default})
